import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import {
  map,
  catchError,
  concatMap,
  exhaustMap,
  switchMap,
  mergeMap,
} from 'rxjs/operators';
import { of } from 'rxjs';
import * as StakeholderActions from './stakeholder.actions';
import { StakeholderService } from '../../services/stakeholder.service';

import { StakeholderReferenceDto } from '@cradua/data';

@Injectable()
export class StakeholderEffects {
  // loadStakeholderReference$ = createEffect(() =>
  // 	this.actions$.pipe(
  // 		ofType(StakeholderReferenceActions.loadStakeholderReference),
  // 		exhaustMap((_) =>
  // 			this.stakeholderreferenceService.getStakeholderReference("Club").pipe(
  // 				map((data) => {
  // 					console.log('data from database ', data);
  // 					return StakeholderReferenceActions.loadStakeholderReferenceSuccess({ stakeholderreference: data });
  // 				}),
  // 				catchError((error) => of(StakeholderReferenceActions.loadStakeholderReferenceFailure({ error })))
  // 			)
  // 		)
  // 	)
  // );

  transformedData(reftype: string, data: any[]): StakeholderReferenceDto[] {
    let transformData: StakeholderReferenceDto[];
    if (reftype === 'Language') {
      transformData = data.map((b) => {
        return {
          Type: 'Language',
          id: b.id,
          Name: b.LanguageName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'Club') {
      transformData = data.map((b) => {
        return {
          Type: 'Club',
          id: b.id,
          Name: b.ClubName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: b.CountryId,
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'ContactType') {
      transformData = data.map((b) => {
        return {
          Type: 'ContactType',
          id: b.id,
          Name: b.ContactTypeName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'League') {
      transformData = data.map((b) => {
        return {
          Type: 'League',
          id: b.id,
          Name: b.LeagueName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: b.CountryId,
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'Organization') {
      transformData = data.map((b) => {
        return {
          Type: 'Organization',
          id: b.id,
          Name: b.OrganizationName,
          Desc: '',
          Address: b.OrganizationAddress,
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: b.SectorId,
          StakeholderGroupId: '',
        };
      });
    }

    if (reftype === 'Property') {
      transformData = data.map((b) => {
        return {
          Type: 'Property',
          id: b.id,
          Name: b.PropertyName,
          Desc: '',
          Address: '',
          Location: b.PropertyLocation,
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'Sector') {
      transformData = data.map((b) => {
        return {
          Type: 'Sector',
          id: b.id,
          Name: b.SectorName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }

    if (reftype === 'SocialMediaType') {
      transformData = data.map((b) => {
        return {
          Type: 'SocialMediaType',
          id: b.id,
          Name: b.SocialMediaTypeName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }

    if (reftype === 'StakeholderGroup') {
      transformData = data.map((b) => {
        return {
          Type: 'StakeholderGroup',
          id: b.id,
          Name: b.StakeholderGroupName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }

    if (reftype === 'StakeholderSubGroup') {
      transformData = data.map((b) => {
        return {
          Type: 'StakeholderSubGroup',
          id: b.id,
          Name: b.StakeholderSubGroupName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: b.StakeholderGroupId,
        };
      });
    }

    if (reftype === 'AreaOfInterest') {
      transformData = data.map((b) => {
        return {
          Type: 'AreaOfInterest',
          id: b.id,
          Name: b.AreaOfInterestDesc,
          Desc: b.AreaOfInterestDesc,
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }

    if (reftype === 'PoliticalParty') {
      transformData = data.map((b) => {
        return {
          Type: 'PoliticalParty',
          id: b.id,
          Name: b.PoliticalPartyName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'Title') {
      transformData = data.map((b) => {
        return {
          Type: 'Title',
          id: b.id,
          Name: b.TitleName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }

    return transformData;
  }

  loadStakeholder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StakeholderActions.loadStakeholder),
      mergeMap((action) =>
        this.stakeholderService.getStakeholder().pipe(
          map((data) => {
            //console.log("Data in Effects Stakeholder ", data);
            return StakeholderActions.loadStakeholderSuccess({
              stakeholder: data,
            });
          }),
          catchError((error) =>
            of(StakeholderActions.loadStakeholderFailure({ error }))
          )
        )
      )
    )
  );

  addStakeholder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StakeholderActions.addStakeholder),
      concatMap(({ newStakeholder }) =>
        this.stakeholderService.createStakeholder(newStakeholder).pipe(
          map((data) =>
            StakeholderActions.addStakeholderSuccess({ newStakeholder: data })
          ),
          catchError((error) =>
            of(
              StakeholderActions.addStakeholderFailure({
                error: error.error.message,
              })
            )
          )
        )
      )
    )
  );

  updateStakeholder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StakeholderActions.updateStakeholder),
      // map((action) => {updateStakeholderReference: action.updateStakeholderReference, type: action.reftype}),
      concatMap(({ updateStakeholder, deletedData }) =>
        this.stakeholderService
          .updateStakeholder(updateStakeholder, deletedData)
          .pipe(
            map(() =>
              StakeholderActions.updateStakeholderSuccess({
                updateStakeholder: updateStakeholder,
              })
            ),
            catchError((error) =>
              of(
                StakeholderActions.updateStakeholderFailure({
                  error: error.message,
                })
              )
            )
          )
      )
    )
  );

  removeStakeholder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StakeholderActions.removeStakeholder),
      // map((action) => action.ids),
      concatMap(({ ids }) =>
        this.stakeholderService.deleteStakeholder(ids).pipe(
          map(() => StakeholderActions.removeStakeholderSuccess({ ids })),
          catchError((error) =>
            of(
              StakeholderActions.removeStakeholderFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private stakeholderService: StakeholderService
  ) {}
}
